import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { interval } from "rxjs";

import {} from "src/app/models/printing.model";
import { resolveHostedUrl } from "src/app/constants/hosted-api-urls";
import { CommonService } from "./common.service";
import { MessageService } from "./message.service";

@Injectable({
  providedIn: "root",
})
export class OrderCountService {
  orderCount: number = 0;
  refreshOrderPage: boolean = false;
  redisPollingInterval: number = 30000; // default polling interval
  orderPollingActive;
  restaurant_id: string = "";
  constructor(
    private _http: HttpClient,
    private messageService: MessageService,
    private commonService: CommonService
  ) {
    this.commonService.orderReceivedAck$.subscribe((_response) => {
      // this.messageService.showSuccess(response);
      //TODO we will add some analytics after acknowledgement
    });
  }

  startPolling() {
    if (!this.orderPollingActive) {
      this.orderPollingActive = interval(this.redisPollingInterval);
      this.orderPollingActive.subscribe(() => {
        this.toPoll();
      });
    }
  }
  endPolling() {
    try {
      this.orderCount = 0;
      this.orderPollingActive.unsubscribe();
    } catch (error) {}
  }

  /**
   * It checks the order count from the server and if it's different from the current order count, it
   * updates the order count and sends a message to the order page to refresh
   */
  toPoll() {
    this.checkNewOrder(this.restaurant_id).subscribe(
      (response) => {
        if (response.statusCode === 200) {
          let redisCount = response.count || 0;

          if (redisCount !== this.orderCount) {
            this.orderCount = redisCount;
            this.refreshOrderPage = true;
            this.commonService.orderActionMessage({
              action: 10,
              orderCount: this.orderCount,
            });
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  checkNewOrder(rest_id) {
    return this._http.get<any>(
      `${resolveHostedUrl('nestURL')}/api/redis/order-count/${rest_id}`
    );
  }

  get isOrderSyncSettingActive() {
    return !!((JSON.parse(localStorage.getItem("restaurant_settings")) || {})[
      "global"
    ] || {})["is_order_sync"];
  }
}
